import About from './About'
import Contact from './Contact'
import FAQs from './FAQs'
import Features from './Features'
import Footer from './Footer'
import HeroBanner from './HeroBanner'
import HeroSection from './HeroSection'
import MultioutletBanner from './MultioutletBanner'
import OnespaceSection from './OnespaceSection'
import PlanSection from './PlanSection'



export default function Home() {
 

    return (
        <>
            <HeroSection />
            <HeroBanner />
            <About />
            <Contact />
            <Features />
            <OnespaceSection />
            <MultioutletBanner />
            <PlanSection />
            <FAQs />
            <Footer />
        </>
    )
}
